export { default } from './CreatePromotion'
